import { api } from './api';

const endpoint = '/dash/auth/';

export const apiAuth = {

  async login(data){
    const url = `${endpoint}login`;
    const result = await api.postNoAuth(url, data);
    return result.data;
  },
}